import {EventEmitter} from "events";
import dispatcher from "./Dispatcher"
import uuid from 'react-uuid'

class AlertStore extends EventEmitter {
  constructor() {
    super()
    this.alerts =  [];
  }

  getIndexById(id) {
    var objectIndex;
    for(var index = 0; index < this.alerts.length; index++) {
      if (this.alerts[index].id == id) {
        objectIndex = index;
        break;
      }
    }
    return objectIndex;
  }

  shiftAlert(id, direction) {
    var index = this.getIndexById(id);
    if ("up" == direction && index > 0) {
      var tmp = this.alerts[index];
      this.alerts[index] = this.alerts[index - 1];
      this.alerts[index -  1] = tmp;
    }
    if ("down" == direction && index < this.alerts.length -1) {
      var tmp = this.alerts[index];
      this.alerts[index] = this.alerts[index +1];
      this.alerts[index + 1] = tmp;
    }
  }

  createAlert(symbol, name, exchange, currency, min, max, sma, message) {
    if(symbol == null || "" == symbol) {
      return;
    }

    if (sma == null || "" == sma) {
      sma = 0;
    }

    var newElement = {
      id: uuid(),
      type: "standard",
      symbol: symbol ? symbol : "",
      name: name ? name : "",
      exchange: exchange ? exchange : "",
      currency: currency ? currency : "",
      sma: sma ? sma : "",
      min: min ? min : "",
      max: max ? max : "",
      message: message ? message : ""
    };
    this.alerts.unshift(newElement);
  }

  editAlert(id, symbol, name, exchange, currency, min, max, sma, message) {
    if(symbol == null || "" == symbol) {
      return;
    }

    if (min == null && max == null) {
      return;
    }

    if (sma == null || "" == sma) {
      sma = 0;
    }

    var index = this.getIndexById(id);
    this.alerts[index] = {
      id: id,
      type: "standard",
      symbol: symbol ? symbol : "",
      name: name ? name : "",
      exchange: exchange ? exchange : "",
      currency: currency ? currency : "",
      sma: sma ? sma : "",
      min: min ? min : "",
      max: max ? max : "",
      message: message,
    };
  }

  getAll() {
    return this.alerts;
  }

  getSave() {
    return this.save;
  }

  getSelectedAlert() {
    return this.selectedAlert;
  }

  getCoordinates() {
    return [this.coordinate_x, this.coordinate_y];
  }

  handleAction(action) {
    switch(action.type) {
      case "CREATE_ALERT": {
        this.createAlert(action.data.symbol, action.data.name, action.data.exchange, action.data.currency, action.data.min, action.data.max, action.data.sma, action.data.message);
        this.emit("change");
        break;
      }
      case "DELETE_ALERT" : {
        this.alerts = this.alerts.filter(o => o.id != action.id);
        this.emit("change");
        break;
      }
      case "SHIFT_ALERT": {
        this.shiftAlert(action.id, action.direction);
        this.emit("change");
        break;
      }
      case "EDIT_ALERT" : {
        this.editAlert(action.alert.id, action.alert.symbol, action.alert.name, action.alert.exchange, action.alert.currency, action.alert.min, action.alert.max, action.alert.sma, action.alert.message);
        this.emit("change");
        break;
      }
      case "REPLACE_ALERTS" : {
        this.alerts = action.alerts;
        this.emit("change");
        break;
      }
      case "VISUALIZE_ALERT" : {
        this.selectedAlert = action.alert;
        this.emit("present");
        break;
      }
      case "SET_SAVE" : {
        this.save = action.save;
        this.emit("save_changed");
        break;
      }
      case "COORDINATES_CHANGED" : {
        this.coordinate_x = action.x;
        this.coordinate_y = action.y;
        this.emit("coordinates_changed")
        break;
      }
      case "COORDINATES_SELECTED" : {
        this.emit("coordinates_selected")
        break;
      }
    }
  }
}

const alertStore = new AlertStore();
dispatcher.register(alertStore.handleAction.bind(alertStore));
window.display = dispatcher;
export default alertStore;
